import React, {Component, Fragment} from 'react';
import FaceMatch from "../Components/FaceMatch";
import MenuBar from "../Components/MenuBar";
import Footer from "../Components/Footer";
class FaceMatchPage extends Component {
    render() {
        return (
            <Fragment>
                <MenuBar/>
                <FaceMatch/>
                <Footer/>
            </Fragment>
        );
    }
}

export default FaceMatchPage;